import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { estados, estadosCidade } from 'src/app/util/constantes';
import { AuthService } from 'src/app/security/services/auth-service';
import { ClientService } from 'src/app/view/pdv/services/client.service';
import { ClienteCad } from '../../cliente-cad';
import { EmpresaService } from '../../services/empresa.service';
import { ErrorHandlerService } from '../../services/error-handler.service';

@Component({
  selector: 'app-cad-client-resum',
  templateUrl: './cad-client-resum.component.html',
  styleUrls: ['./cad-client-resum.component.scss']
})
export class CadClientResumComponent implements OnInit, OnChanges {

  @Input() display = false;
  @Output() eventCadClient = new EventEmitter();
  @Output() eventCloser = new EventEmitter();

  typePesson = [
    { label: 'Fisica', value: 'FISICA' },
    { label: 'Juridica', value: 'JURIDICA' }
  ];

  cidades = [];
  city: any;
  ufs = estados;
  operacoesFiscais: any[] = [];
  empresas: any[] = [];
  empresasSelecionadas: number[] = [];

  client = new ClienteCad();

  constructor(
    private clientService: ClientService,
    private empresaService: EmpresaService,
    private auth: AuthService,
    private messageService: MessageService,
    private error: ErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.loadOperacoesFiscais();
    this.loadEmpresas();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.display?.currentValue === true && this.operacoesFiscais.length === 0) {
      this.loadOperacoesFiscais();
    }
    if (changes.display?.currentValue === true) {
      this.empresasSelecionadas = [this.auth.getIdEmpresa()];
    }
  }

  private loadOperacoesFiscais(): void {
    this.clientService.findOperacoesFiscais()
      .then((result) => { this.operacoesFiscais = result; })
      .catch((error) => this.error.handleError(error));
  }

  searchCity(event) {

    const ufs = estadosCidade.filter(c => c.sigla === this.client.uf);
    this.cidades = [];


    ufs[0].cidades.filter((c) => {
      c.nome.includes(event.query);
    });

    ufs[0].cidades.forEach(c => {
      if (c.nome.toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
        this.cidades.push(c);
      }
    });
  }

  citySelected(event) {
    this.client.cidade = event.nome;
    this.client.codigoIbgeCidade = event.ibge;
  }

  async save() {
    try {
      const existente = await this.findClienteExistente();

      if (existente?.situacao === 'DISPONIVEL_PARA_VINCULO') {
        await this.clientService.vincularEmpresas(existente.id, this.idsEmpresasParaVinculo());
        this.finish({ ...this.client, id: existente.id, nome: existente.nome }, 'Cliente já cadastrado em outra empresa, vinculado com sucesso');
        return;
      }

      if (existente?.situacao === 'VINCULADO_EMPRESA') {
        this.finish({ ...this.client, id: existente.id, nome: existente.nome }, 'Cliente já cadastrado nesta empresa');
        return;
      }

      const result = await this.clientService.createClient(this.client);
      const idsEmpresas = this.idsEmpresasParaVinculo();
      if (idsEmpresas.length > 1) {
        await this.clientService.vincularEmpresas(result.id, idsEmpresas);
      }
      this.finish(result, 'Cliente salvo com sucesso');
    } catch (error) {
      this.error.handleError(error);
    }
  }

  private findClienteExistente() {
    return this.client.cpfCnpj
      ? this.clientService.consultarVinculoPorDocumento(this.client.cpfCnpj)
      : Promise.resolve(undefined);
  }

  private idsEmpresasParaVinculo(): number[] {
    return Array.from(new Set([this.auth.getIdEmpresa(), ...this.empresasSelecionadas]));
  }

  private finish(client: any, message: string): void {
    this.client = new ClienteCad();
    this.empresasSelecionadas = [this.auth.getIdEmpresa()];
    this.eventCadClient.emit({ client });
    this.closer();

    this.messageService.add({ severity: 'success', summary: 'Info', detail: message });
  }

  private loadEmpresas(): void {
    const idEmpresaToken = this.auth.getIdEmpresa();
    this.empresasSelecionadas = [idEmpresaToken];

    this.empresaService.getEmpresasDoUsuario()
      .then((result) => {
        this.empresas = result.map(e => ({ label: e.nome, value: e.id, disabled: e.id === idEmpresaToken }));
      })
      .catch((error) => this.error.handleError(error));
  }
  closer() {
    this.display = false;
    this.eventCloser.emit(false);
  }

}
